import eventBus from './EventBus';

const PX_PER_CM = 96 / 2.54;

class GridManager {
  constructor(canvasManager, gridSizeMm = 10) {
    this.canvasManager = canvasManager;
    this.gridSizeMm = gridSizeMm;
    this.visible = false;
    this.snapEnabled = false;
    this._snapHandler = null;
  }

  show() {
    if (this.visible) return;
    this.visible = true;
    // Grid rendering is handled by CanvasArea CSS overlay
    eventBus.emit('grid:changed', { visible: true, snapEnabled: this.snapEnabled });
  }

  hide() {
    if (!this.visible) return;
    this.visible = false;
    eventBus.emit('grid:changed', { visible: false, snapEnabled: this.snapEnabled });
  }

  toggle() {
    if (this.visible) {
      this.hide();
    } else {
      this.show();
    }
    return this.visible;
  }

  isVisible() {
    return this.visible;
  }

  setGridSize(mm) {
    this.gridSizeMm = mm;
  }

  enableSnap() {
    if (this.snapEnabled) return;
    this.snapEnabled = true;
    const gridPx = (this.gridSizeMm / 10) * PX_PER_CM;
    this._snapHandler = (e) => {
      const target = e.target;
      if (!target || target.isGrid || target.isBleed) return;
      target.set({
        left: Math.round(target.left / gridPx) * gridPx,
        top: Math.round(target.top / gridPx) * gridPx,
      });
    };
    this.canvasManager.canvas.on('object:moving', this._snapHandler);
    eventBus.emit('grid:changed', { visible: this.visible, snapEnabled: true });
  }

  disableSnap() {
    if (!this.snapEnabled) return;
    this.snapEnabled = false;
    if (this._snapHandler) {
      this.canvasManager.canvas.off('object:moving', this._snapHandler);
      this._snapHandler = null;
    }
    eventBus.emit('grid:changed', { visible: this.visible, snapEnabled: false });
  }

  toggleSnap() {
    if (this.snapEnabled) {
      this.disableSnap();
    } else {
      this.enableSnap();
    }
    return this.snapEnabled;
  }

  dispose() {
    this.disableSnap();
  }
}

export default GridManager;
